import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class EventsService {

    private readonly options = {
        withCredentials: true
    };

    constructor(private http: HttpClient) { }

    public getAll(): Promise<any> {
        return this.http.get<string>('api/events', this.options).toPromise();
    }

    public save(event: any): Promise<any> {
        return this.http.put<string>('api/events', event, this.options).toPromise();
    }

}
